import React, { useState, useEffect } from 'react'
import SchedulePerDay from './SchedulePerDay';

function Schedule() {

    let initial = []

    const [currentDates, setcurrentDates] = useState([])
    const [loading, setLoading] = useState(true)
    const [DisableBtn, setDisableBtn] = useState(false)
    let dayTiming = [
        ["7:00", "8:00", "9:00", "10:00", "11:00"],
        ["7:00", "8:00", "9:00", "10:00"],
        ["7:00", "8:00", "9:00", "10:00", "11:00", "13:45"],
        [],
        ["7:00", "8:00", "10:00", "14:00", "15:00", "18:30", "19:30"],
        [],
        ["7:00", "8:00", "10:00", "12:30", "15:00"],
    ]


    let dates = (d, backward) => {
        let limit = 7
        let dates = []
        let days = []
        if (d) {
            var date = new Date(`${d} 2022`);
        } else {
            var date = new Date();
            dates.push(date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }))
            days.push(date.toLocaleDateString(undefined, { weekday: 'long' }))
            limit = 6
        }
        for (let i = 0; i < limit; i++) {
            if (backward) {
                date.setDate(date.getDate() - 1);
            dates.unshift(date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }))
            days.unshift(date.toLocaleDateString(undefined, { weekday: 'long' }))
            }
            else {
                date.setDate(date.getDate() + 1);
                dates.push(date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }))
                days.push(date.toLocaleDateString(undefined, { weekday: 'long' }))
            }
        }
        setcurrentDates({ dates: dates, days: days })
        setLoading(false)
    }
    // console.log((currentDates.dates[0]))

    useEffect(() => {
        // let today = new Date().toLocaleDateString(undefined, { month: 'short', day: 'numeric' })
        // if (today == currentDates.dates[0]) {
        //     setDisableBtn(true)
        // } else {
        //     setDisableBtn(false)
        // }
        setLoading(false)
    console.log(currentDates)
    }, [currentDates])

    useEffect(() => {
        dates()
    }, [])

    return (
        <>
            {loading && <p>Loading</p>}
            {!loading &&
                <div className="row justify-content-between">
                    <button className="btn btn-sm col-md-1 shadow-none align-self-start " disabled={DisableBtn} onClick={() => dates(currentDates.dates[0], true)}   ><ion-icon style={{ color: `${DisableBtn ? "grey" : "#FF5722"}`, fontSize: "30px" }} name="chevron-back-outline"></ion-icon></button>
                    {currentDates.dates.map((date, i) => {
                        return <SchedulePerDay date={date} timing={dayTiming[i]} day={currentDates.days[i]} maxtiming={7} />
                    })}
                    <button className="btn col-md-1 shadow-none align-self-start" onClick={() => dates(currentDates.dates[currentDates.dates.length - 1], false)}><ion-icon style={{ color: "#FF5722", fontSize: "30px" }} name="chevron-forward-outline"></ion-icon></button>
                </div>
            }
        </>
    )
}

export default Schedule